import { IconButton, InputAdornment } from '@mui/material';
import ClearIcon from '@mui/icons-material/ClearTwoTone';

import styles from './Form.module.css';

interface ClearInputAdornmentProps {
  onClear?: () => void;
  inputValue?: unknown;
  inputIsDisabled?: boolean;
}

export default function ClearInputAdornment(props: ClearInputAdornmentProps) {
  const isHidden =
    !props.onClear ||
    props.inputValue === undefined ||
    props.inputValue === null ||
    props.inputValue === '' ||
    props.inputValue === 0 ||
    props.inputIsDisabled;

  return (
    <InputAdornment position='end'>
      <IconButton
        className={styles['clear-ico-btn']}
        onClick={props.onClear}
        tabIndex={-1}
        style={isHidden ? { visibility: 'hidden', pointerEvents: 'none' } : undefined}>
        <ClearIcon
          titleAccess='Clear'
          fontSize='inherit'
        />
      </IconButton>
    </InputAdornment>
  );
}
